"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceProvider = void 0;
exports.VoiceProvider = {
    Speechify: "speechify",
    Neural: "neural",
    Resemble: "resemble",
    Azure: "azure",
    Standard: "standard",
    ElevenLabs: "eleven-labs",
    Omicron: "omicron",
};
